export enum InlineAlign {
	center = 'center',
	left = 'left',
	right = 'right'
}
